export default { baseURL: 'https://dev.regionsanmartin.gob.pe' }
